import React from "react";
import styles from "./expert-gallery.module.css";
import { ExpertCard } from "../../ui/expert-card/expert-card";

const SAMPLE_IMAGES = [
  "/assets/dr-pics/placeholder_1.PNG",
  "/assets/dr-pics/placeholder_2.PNG",
  "/assets/dr-pics/dr_lisa_mosconi.PNG",
  "/assets/dr-pics/dr_aviv_romm.PNG",
  "/assets/dr-pics/dr_stacy_sims.PNG",
]

// Placeholder data - increased to 25 to ensure 5 rows of 5
const GALLERY_EXPERTS = Array(15).fill(null).map((_, i) => ({
  id: i,
  name: `Expert Name ${i + 1}`,
  specialty: "Clinical Psychology",
  bio: "Specializing in cognitive behavioral therapy for women navigating menopausal transitions.",
  image: SAMPLE_IMAGES[i % SAMPLE_IMAGES.length],
  institution: "Clinical Psychologist"
}));

const ExpertRow = ({ experts, isShifted }: { experts: any[], isShifted: boolean }) => {
  const scrollContainerRef = React.useRef<HTMLDivElement>(null);
  const scrollIntervalRef = React.useRef<number | null>(null);

  const startScroll = (speed: number) => {
    if (scrollIntervalRef.current) return;

    const scrollStep = () => {
      if (scrollContainerRef.current) {
        scrollContainerRef.current.scrollLeft += speed;
        scrollIntervalRef.current = requestAnimationFrame(scrollStep);
      }
    };
    scrollIntervalRef.current = requestAnimationFrame(scrollStep);
  };

  const stopScroll = () => {
    if (scrollIntervalRef.current) {
      cancelAnimationFrame(scrollIntervalRef.current);
      scrollIntervalRef.current = null;
    }
  };

  return (
    <div className={styles.rowContainer}>
      {/* Hover Zones */}
      <div
        className={`${styles.hoverZone} ${styles.hoverZoneLeft}`}
        onMouseEnter={() => startScroll(-5)}
        onMouseLeave={stopScroll}
      >
        <span className="material-icons" style={{ color: '#94a3b8' }}>chevron_left</span>
      </div>
      <div
        className={`${styles.hoverZone} ${styles.hoverZoneRight}`}
        onMouseEnter={() => startScroll(5)}
        onMouseLeave={stopScroll}
      >
        <span className="material-icons" style={{ color: '#94a3b8' }}>chevron_right</span>
      </div>

      <div className={styles.rowScrollArea} ref={scrollContainerRef}>
        <div className={`${styles.galleryRowTrack} ${isShifted ? styles.rowShifted : ""}`}>
          {experts.map((expert) => (
            <div key={expert.id} className={styles.expertCardWrapper}>
              <ExpertCard
                image={expert.image}
                name={expert.name}
                role={expert.institution}
                description={expert.bio}
                socials={{
                  instagram: "#",
                  substack: "#",
                  website: "#"
                }}
              />
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default function ExpertGallery() {
  // Chunk into rows of 5
  const rows = [];
  for (let i = 0; i < GALLERY_EXPERTS.length; i += 5) {
    rows.push(GALLERY_EXPERTS.slice(i, i + 5));
  }

  return (
    <section className={styles.section}>
      <div className={styles.galleryWrapper}>
        {rows.map((rowExperts, rowIndex) => (
          <ExpertRow
            key={rowIndex}
            experts={rowExperts}
            isShifted={rowIndex % 2 !== 0}
          />
        ))}
      </div>
    </section>
  );
}
